import {BaseCardData} from '@colonist/game-card-types'
import {GameFont} from '../../GameFont'
import {SectionView} from '../../ui_canvas_engine/SectionView'
import {TextView} from '../../ui_canvas_engine/TextView'
import {PIXI} from '@colonist/pixi'

export class UIGamePopupCondensedCardInformationView extends SectionView {
    private readonly cardData: BaseCardData
    private readonly titleTextView: TextView
    private readonly bodyTextView: TextView

    constructor(cardData: BaseCardData, x: number, y: number, w: number, h: number, container: PIXI.Container) {
        super(x, y, w, h, container)
        this.cardData = cardData
        const {tipTitle, tipBody} = this.cardData

        const titleY = h * 0.1
        this.titleTextView = new TextView(tipTitle, 0, titleY, w, h, this, GameFont.Size.Small)
        this.titleTextView.changeStyle({
            fontWeight: GameFont.Weight.Bold,
            align: 'left',
        })
        this.titleTextView.repositionY(false)

        const bodyY = this.titleTextView.y + this.titleTextView.height
        this.bodyTextView = new TextView(tipBody, 0, bodyY, w, h, this, GameFont.Size.Small)
        this.bodyTextView.repositionY(false)
        this.bodyTextView.changeStyle({
            align: 'left',
        })
    }
}
